// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Fjlg","inputWrap":"Table_inputWrap__HjB0G","col":"Table_col__BljlD","bmiTooltip":"Table_bmiTooltip__cFLWg"};